import { createContext } from 'react';
import data from './strings';

const StringsContext = createContext(data);

export const StringsProvider = StringsContext.Provider;

export default StringsContext;
